import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";

const server = EnvSettings.server;

export default function NewCompany(props) {
  const { t } = useTranslation();
  const [company, setCompany] = useState();
  const dispatch = useDispatch();

  function submitForm() {
    if (company === "" || company === null || company === undefined) {
      // Set error
      console.log("company error");
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ company: company, token: getToken() }),
    };
    fetch(server + "/create_new_company", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
      });
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          autoComplete="uname"
          name="userName"
          variant="outlined"
          required
          fullWidth
          id="userName"
          label={t("newCompany.company")}
          autoFocus
          onChange={(e) => setCompany(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <Button variant="outlined" onClick={submitForm}>
          <Typography>{t("newCompany.submit")}</Typography>
        </Button>
      </Grid>
    </Grid>
  );
}
